import axios from './axios';
import qs from 'qs';
import {getAppUrl} from '@console/helpers/url.js';

export default {
  addMember({orgId, email, role}) {
    const data = {
      email,
      role,
    };
    return axios().post(
      getAppUrl() + '/orgs/' + orgId + '/invitations',
      qs.stringify(data)
    );
  },

  saveOrg(org) {
    // Endpoint URL
    let endpointUrl = getAppUrl() + '/orgs';

    if (org.id) {
      endpointUrl += '/' + org.id;
    }

    return axios().post(endpointUrl, org);
  },

  getOrders(orgId) {
    const query = qs.stringify({
      orgId: orgId,
    });

    return axios().get(getAppUrl() + '/orders?' + query);
  },

  getPendingOrders(orgId) {
    const query = qs.stringify({
      orgId: orgId,
      approvalPending: 1,
    });

    return axios().get(getAppUrl() + '/orders?' + query);
  },

  requestOrderApproval({orgId, orderNumber, fields} = {fields: null}) {
    return axios().post(
      getAppUrl() + '/orders/' + orderNumber + '/request-approval',
      {
        orgId: orgId,
        fields,
      }
    );
  },

  rejectRequest({orgId, orderNumber}) {
    return axios().post(
      getAppUrl() + '/orders/' + orderNumber + '/reject-request',
      {
        orgId: orgId,
      }
    );
  },

  getOrgMember({orgId, userId}) {
    return axios().get(getAppUrl() + '/orgs/' + orgId + '/members/' + userId);
  },

  getOrgMembers({orgId}) {
    return axios().get(getAppUrl() + '/orgs/' + orgId + '/members');
  },

  getOrg(orgId) {
    return axios().get(getAppUrl() + '/orgs/' + orgId);
  },

  getOrgs() {
    return axios().get(getAppUrl() + '/orgs');
  },

  removeMember({orgId, memberId}) {
    return axios().delete(
      getAppUrl() + '/orgs/' + orgId + '/members/' + memberId
    );
  },

  getInvitations({orgId}) {
    return axios().get(getAppUrl() + '/orgs/' + orgId + '/invitations');
  },

  getUserInvitations() {
    return axios().get(getAppUrl() + '/orgs/invitations');
  },

  cancelInvitation({orgId, userId}) {
    return axios().delete(
      getAppUrl() + '/orgs/' + orgId + '/invitations/' + userId
    );
  },

  acceptInvitation({orgId}, data) {
    return axios().post(getAppUrl() + '/orgs/' + orgId + '/invitation', data);
  },

  declineInvitation({orgId}) {
    return axios().delete(getAppUrl() + '/orgs/' + orgId + '/invitation');
  },

  setRole({orgId, userId, role}) {
    return axios().post(
      getAppUrl() + '/orgs/' + orgId + '/members/' + userId + '/role',
      {
        role,
      }
    );
  },

  setInvitationRole({orgId, userId, role}) {
    return axios().post(
      getAppUrl() + '/orgs/' + orgId + '/invitations/' + userId,
      {
        role,
      }
    );
  },

  saveMember({orgId, userId}, data) {
    return axios().post(
      getAppUrl() + '/orgs/' + orgId + '/members/' + userId,
      data
    );
  },

  deleteOrg(orgId) {
    return axios().delete(getAppUrl() + '/orgs/' + orgId);
  },
};
